/* eslint-disable no-unused-expressions */
import React, { useState } from 'react';
import * as PropTypes from 'prop-types';
import { displayToast } from '../../Util/Toast';
import LearnArticleContentModalView from '../../Components/LearnArticleContentAdmin/Modal';

const LearnArticleContentAdminModal = ({
                                      learnArticleId,
                                      updateLanguageUri,
                                      languages = '[]',
                                      articleLanguages = '[]'
                                  }) => {
    const [posting, setPosting] = useState(false);

    const postLanguage = async (payload) => {
        setPosting(true);
        const formData = new FormData();
        formData.append('language_code', payload.languageCode);
        if (payload.title !== null && payload.title !== undefined) formData.append('title', payload.title);
        if (payload.shortDescription !== null && payload.shortDescription !== undefined) formData.append('short_description', payload.shortDescription);
        if (payload.metaDescription !== null && payload.metaDescription !== undefined) formData.append('meta_description', payload.metaDescription);
        if (payload.metaKeywords !== null && payload.metaKeywords !== undefined) formData.append('meta_keywords', payload.metaKeywords);
        formData.append('content', payload.content || '');

        try {
            const res = await fetch(updateLanguageUri, {
                method: 'POST',
                headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
                body: formData,
                credentials: 'same-origin'
            });
            if (res.status === 204) {
                displayToast('Article updated', 'success');
                return location.reload();
            }
            await res.text();
            setPosting(false);
            displayToast('Error submitting article content', 'error');
        } catch (e) {
            setPosting(false);
            displayToast('Error submitting article content', 'error');
        }
    };

    return (
        <LearnArticleContentModalView
            posting={posting}
            languages={languages}
            articleLanguages={articleLanguages}
            onSubmit={postLanguage}
        />
    );
};

export default LearnArticleContentAdminModal;

LearnArticleContentAdminModal.propTypes = {
    learnArticleId: PropTypes.number.isRequired,
    updateLanguageUri: PropTypes.string.isRequired,
    languages: PropTypes.string,
    articleLanguages: PropTypes.string
};
